import React, {useEffect} from "react";
import styles from "./ResumoArtigo.module.css"
import {useNavigate} from "react-router-dom";
import Viewer from "@toast-ui/editor/dist/toastui-editor-viewer";
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

const ResumoArtigo = ({titulo, data, markdown, author, id}) => {
    const navigate = useNavigate();

    markdown = markdown.split("\n").slice(0, 5).join("\n");

    useEffect(() => {
        const viewer = new Viewer({
            el: document.querySelector(`#viewer-${id}`),
            height: '600px',
            initialValue: markdown
        });
    }, []);

    return(
        <div className={styles.resumoArtigo} onClick={()=> navigate(`/lerArtigo/${id}`)}>
            <h1 className={styles.titulo}>{titulo}</h1>
            <span className={styles.data}>{data}</span>
            <div id={`viewer-${id}`}></div>
            <span className={styles.author}>{author}</span>
        </div>
    )
}

export default ResumoArtigo;